module.exports = __webpack_public_path__ + "img/arrowright.06bf033d.svg";